import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { ModalManager } from '@3plearning/react-components';
import modalActions from './modal-actions';

/**
 * ModalContainer Redux component
 * Passes list of modals through to ModalManager component
 *
 */

export const ModalContainer = ({ modalMessages, closeModal }) => (
    <ModalManager modals={modalMessages} onClose={closeModal} />
);

ModalContainer.propTypes = {
    modalMessages: PropTypes.array,
    closeModal: PropTypes.func
};

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        modalMessages: state.modalMessages
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            closeModal: modalActions.closeModal
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);



// WEBPACK FOOTER //
// ./containers/modal-container/modal-container.js